export default __webpack_public_path__ + "static/media/bg-15.5b9bc9a5.png";